import { Controller } from "@hotwired/stimulus"

// Auto-triggers an external-data fetch once when the element connects, used for
// fields/blocks configured with "load on open". The element is a Turbo POST link
// (data-turbo-method="post"); clicking it lets Turbo issue the request with the
// CSRF token. The server only renders this controller when a fetch is actually
// wanted (auto_fetch on, no value yet, report still editable).
export default class extends Controller {
  connect() {
    if (this.hasFetched) return
    this.hasFetched = true
    this.element.click()
  }
}
